export const GET_LEAD_DETAILS = "GET_LEAD_DETAILS";
export const GET_LEAD_STATUS = "GET_LEAD_STATUS";